import { listTiers } from "./services/catalog";

/**
 * Every service now sends the human label beside each id it returns (a person's name, a customer's
 * name, an order number, a SKU code), so screens read those directly. What is left here is the one
 * map no response carries: a config keyed by tier id (Tally's per-tier sub-groups) — tiers are a
 * short list, read in one call.
 */
export type Labels = Record<string, string | null>;

/** Every tier id → name, in one list call (tiers are a short list). */
export async function tierNames(): Promise<Labels> {
  try {
    const result = await listTiers({ page: 1, pageSize: 200 });
    return Object.fromEntries(result.items.map((tier) => [tier.id, tier.name]));
  } catch {
    return {};
  }
}

/** The label for an id, or "—" when none resolved. Never the id itself. */
export function labelOf(labels: Labels | undefined, id: string | null | undefined): string {
  if (!id) return "—";
  return labels?.[id] ?? "—";
}
